import zroute from './index.js'

export const ZiggyVue = {
  install: (v, options) => {
    const r = (name, params, absolute, config = options) => zroute(name, params, absolute, config)
    v.mixin({
      methods: {
        zroute: r,
      },
    })
  },
}
